module.exports = __webpack_public_path__ + "img/pr-3.6e18882c.png";